/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Delete_ButtonInputs */



/**
* | output |
* | --- |
* | "Delete Commit" |
*
* @param {Snapshot_History_Delete_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_delete_button = /** @type {((inputs?: Snapshot_History_Delete_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Delete_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le commit")
	if (locale === "de") return /** @type {LocalizedString} */ ("Löschen Commit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina commit")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить Коммит")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar confirmación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除提交")
	if (locale === "ja") return /** @type {LocalizedString} */ ("削除コミット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कमिट हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir Confirmação")
	return /** @type {LocalizedString} */ ("Delete Commit")
});